<template>
    <div class="h-100 ">
        <v-row no-gutters>
            <v-col cols="auto" class="mr-6">
                <v-btn
                        style="padding: 0; margin: 0; min-width: 40px; height: 40px"
                        outlined
                        @click="hideDetails(false)"
                        color="#ACB7C0"
                >
                    <span><v-icon >mdi-arrow-left</v-icon></span>
                </v-btn>
            </v-col>
            <v-col cols="auto" class="mr-4">
                <v-avatar size="40" color="var(--color-4)">
                    <img v-if="item.clientLogo!=null"
                         :src="$root.docsUrl+item.clientLogo"
                         alt="Лого"
                    >
                    <span v-else><v-icon>mdi-image</v-icon></span>
                </v-avatar>
            </v-col>
            <v-col class="py-1">
                <span>{{item.fullName}}</span><div style="display: inline-block; margin-left: 15px" :class="{'bonus-container':true,'bonus-1':item.bonusPacketCode=='BP01','bonus-2':item.bonusPacketCode=='BP02', 'bonus-3':item.bonusPacketCode=='BP03','bonus-0':item.bonusPacketCode=='BP00'}"><div>{{item.bonusPacketName}}</div></div>
            </v-col>
        <!--            <v-spacer></v-spacer>           -->
        </v-row>
        <v-tabs
                class="custom-tabs"
                v-model="selectedTab"
                hide-slider
                show-arrows
        >
            <v-tab>
                Данные профиля
            </v-tab>
            <v-tab>
                История активации бонусов
            </v-tab>
            <v-tab>
                Доступные бонусы
            </v-tab>

        </v-tabs>
        <v-tabs-items class="client-tab-items" v-model="selectedTab" >
            <v-tab-item  class="h-100">
                <clientInfoData class="h-100" :item="item" @hideDetails="hideDetails"></clientInfoData>
            </v-tab-item>
            <v-tab-item class="h-100">
                <clientInfoActivates class="h-100" :item="item"></clientInfoActivates>
            </v-tab-item>
            <v-tab-item class="h-100">
                <clientInfoBonuses class="h-100" :item="item"></clientInfoBonuses>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
    const clientInfoActivates = ()=> import('./ClientInfoActivates')
    const clientInfoBonuses = ()=> import('./ClientInfoBonuses')
    const clientInfoData = ()=> import('./ClientInfoData')

    export default {
        name: "ClientInfo",
        props:['item'],
        components:{
            clientInfoData,
            clientInfoBonuses,
            clientInfoActivates
        },
        data(){
            return{
                selectedTab:null
            }
        },
        methods:{
            hideDetails(isSave){
                this.$emit("hideDetails",isSave)
            }
        }
    }
</script>

<style>

    .client-tab-items{
        height: calc(100% - 88px);
    }
    .client-tab-items.v-window.v-item-group.theme--light.v-tabs-items >.v-window__container {
        height: 100% !important;
    }
</style>

<style lang="scss" scoped>
    .custom-tab{
        display: flex;
    }
</style>